import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import AdmissaoController from '@/assets/ts/controller/AdmissaoController';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import Action from '@/../bower_components/teknisavuecomponents/assets/interfaces/Action';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import ExpectedError from '@/../bower_components/teknisavuecomponents/assets/utils/ExpectedError';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import store from '@/store/store';
import User from '@/assets/ts/interfaces/User';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import Messages from '@/assets/ts/utils/Messages';
import { isBefore, isSameDay, parse } from 'date-fns';
import { DadosVinculo } from '@/assets/ts/interfaces/Admissao';
import EscalaController from '@/assets/ts/controller/EscalaController';
import ComunicadoAcidenteTrabalhoController from '@/assets/ts/controller/ComunicadoAcidenteTrabalhoController';
import DocumentoUtil from '@/assets/ts/utils/DocumentoUtil';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import moment from 'moment';

@Component({
  name: 'NovoComunicadoAcidenteTrabalhoPopup',
  components: {
    TkForm,
    EditableTable,
  },
})
class NovoComunicadoAcidenteTrabalhoPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: 'edit' })
  private readonly mode: string;

  @Prop({ default: () => {} })
  private readonly presetRow: boolean;

  @Prop({ default: false })
  private readonly value: boolean;
  
  // #endregion
  
  // #region [STORE]
  private get user(): User {
    return store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return store.getters.estruturaGerencialAtual;
  }

  private get estruturasGerenciaisStore(): Estrutura[] {
    return this.$store.getters.estruturasGerenciais;
  }

  private get idOperadorSST(): Estrutura[] {
    return this.$store.getters.user.idoperadorsst;
  }

  private get isUserAdmOrSST() {
    return this.user.dp || this.user.idoperadorsst;
  }

  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private tkForm: any = {
    row: {},
    loading: false,
  };

  private estruturasGerenciais: any[] = [];
  private estruturasLegais: any[] = [];
  private vitimas: any[] = [];

  private internalValue = false;

  private loaded = false;

  private dialogHeight = 500;

  private vinculos: any[] = null;

  private row: any = {};

  private descField = this.isUserAdmOrSST ? 'NRNMESTRUTURA' : 'NMESTRUTURA';

  private catSimplificada = true;

  private pessoasConseReg: any[] = null;

  private cid: any[] = null;

  private defaultRow = {
    __is_new: true,
  };

  private fieldCategoryMapCAT = {
    cat: ['NROCORRENCIA','DSOCORRENCIA', 'IDOCORRENCIA', 'QTVITIMASOCORRE'],
    esocial: ['DTHROCORRENCIA', 'DTOCORRENCIA', 'HROCORRENCIA' ,'NRTIPOOCORRE', 'DSTIPOOCORRE', 'NRCLASSIFICACAO', 'DSCLASSIFOCORRE', 'DSOBERSVACAOOCO'],
    infComplementares: ['DTHRRELATOCORRE', 'NRGRAVIDADE', 'DSGRAVIDOCORRE', 'NRINFLUENCIAGERENCIAL', 'DSINFLUGEROCORRE', 'NRCAUSA', 'NRESTRUTURAM'],
  };

  private fieldCategoryMapVitima = {
    vitima: ['NRVITIMA','NRVINCULOM', 'NRPARCNEGOCIO', 'DSACIDENTE', 'NMGRAVIDADE','NRINFLUENCIAGERENCIAL', 'IDINCAPACITADO', 'IDFALTAEPI'],
    esocial: ['NRNATUREZA', 'DSNATUREZAACID', 'IDTIPOCAT', 'DTOBITO', 'IDAFASTAMENTO', 'IDINTERNACAO', 'IDREGPOLICIAL', 'NRREGPOLICIAL', 'NRCAT', 'NRCATORIGEM', 'DTCAT', 'DSLOCALCAT', 'NRTIPOLOCALCAT', 'NRAGENTCAUSAD', 'NRCEPENDERECO', 'CDTIPOENDERECO', 'CDPAIS', 'SGESTADO', 'CDMUNICIPIO', 'NMBAIRROENDERECO', 'CDLOGRADOURO', 'DSENDERECO', 'NRIMOVELENDERECO', 'DSCOMPLEENDERECO', 'DSREFERENCIAENDE', 'DTHRINICATEND', 'QTHRATEINICATEND', 'DTHRFIMATEND', 'QTHRATENDIMENTO', 'QTHRAPOSINICTRAB', 'DTULTDIATRABALHADO', 'DSOBSERVACAOVITIMA',
     'DTINICATEND', 'HRINICATEND', 'DTFIMATEND', 'HRFIMCATEND'],
    catVitima: ['IDACIDENTEBIO', 'DSPROFILAXIA'],
    trabalho: ['QTDIASDEBITADOS', 'QTDIASTRABRESTRITO', 'QTDIASPERDIDOS', 'QTHRPERDIDAS'],
  };

  private fieldCategoryMapParteAtingida = {
    parteAtingida: ['NRVITPARTEATING','NRPARTEATINGIDA', 'LATERALIDADE', 'DSDIAGNOSTICO', 'DSOBSERVACAOVPA'],
  };

  private fieldCategoryMapFichaMedica = {
    esocial: ['NRFICHAMEDICA','NRPESSOA', 'NRINSCRCONSELHOATEND', 'DTHRINIAFASTAMENTO', 'DTHRFIMAFASTAMENTO', 'NRPARCNEGOCIOMEDICO'],
    atendimento: ['NRNATUREZAEXAME', 'NRESTRUTURAMUNIDADEATENDIMENTO', 'DSLOCALATENDIMENTO', 'DTCONCLFICHAMED', 'NRMOTIVOAUSENCIA', 'NRQUEIXA'],
    fichaMedica: ['NRTABRESULTEXAME', 'NRCONTROLEAPTIDAOATEND', 'NRCONTROLEAPTIDAOINSS', 'IDNEXOCAUSAL', 'NRCAT', 'NRBENEFICIO', 'DSOCORRENCIA', 'NRSITUFUNCM', 'DTPREVRETORNO', 'NMSITUFUNCHPROX',],
    imc: ['QTPESO', 'VRALTURA', 'VRIMC', 'GRAUOBESIDADE'],
    sinaisVitais: ['VRTEMPERATURA', 'VRPULSO', 'VRPRESSAOARTSISTOLICA', 'VRPRESSAOARTDIASTOLICA'],
  };

  private fieldCategoryMapDoenca = {
    doenca: ['NRDOENCAFICHAMEDICA','NRCID', 'DSCID', 'DSDOENCAFICHAMEDICA', 'IDOCUPACIONAL'],
  };


  private rowsCAT = {
    cat               : {} as any,
    esocial           : {} as any,
    infComplementares : {} as any
  };

  private rowsVitima = {
    vitima    : {} as any,
    esocial   : {} as any,
    catVitima : {} as any,
    trabalho  : {} as any,
  }

  private rowsParteAtingida = {
    parteAtingida  : {} as any,
  }

  private rowsFichaMedica = {
    esocial      : {} as any,
    atendimento  : {} as any,
    fichaMedica  : {} as any,
    sinaisVitais : {} as any,
    imc          : {} as any,
  }

  private rowsDoenca = {
    doenca : {} as any
  }

  private enderecoFieldsData = {
    tiposEndereco: [] as any[],
    estados: [] as any[],
    municipios: [] as any[],
    logradouros: [] as any[],
  };

  private generalFieldsData = {
    paises: [] as any[],
    estadosBR: [] as any[],
  };

  private rowEndereco: any = {};


  private showDocumentoPopup = false;


  private readonly defaultMainPanelsExpansion = [0, 1];
  private readonly defaultDadosCATPanelsExpansion = [0, 1, 2];
  private readonly defaultDadosVitimaPanelsExpansion = [0, 1];
  private readonly defaultDadosParteAtingidaPanelsExpansion = [0, 1];
  private readonly defaultDadosFichaMedicaPanelsExpansion = [0, 1];
  private readonly defaultDadosDoencaPanelsExpansion = [0,1];

  private mainPanelsExpansion = [];
  private dadosCATPanelsExpansion = [];
  private dadosVitimaPanelsExpansion = [];
  private dadosParteAtingidaPanelsExpansion = [];
  private dadosFichaMedicaPanelsExpansion = [];
  private dadosDoencaPanelsExpansion = [];

  private dataIsLoaded = false;
  private dadosPessoaisFormMode = 'edit';
  private enderecoFormMode = 'edit';
  private contaCorrenteFormMode = 'edit';
  private comunicacaoFormMode = 'edit';

  private dadosCATFormMode = 'edit';
  private dadosVitimaFormMode = 'edit';
  private dadosParteAtingidaFormMode = 'edit';
  private dadosFichaMedicaFormMode = 'edit';
  private dadosDoencaFormMode = 'edit';


  // #endregion

  // #region [ COMPUTED ]
  private get cardTitle(): string {
    const title = 'CAT - Comunicação de Acidente de Trabalho';

    return title;
  }

  private get genericFilter() {
    const filter = {
      NRORG: this.user.nrorg,
    };

    return filter;
  }

  /* CAT - Comunicação de Acidente de Trabalho */
  private get catFields(): Field[] {
    const fields = [
      {
        name: 'NROCORRENCIA',
        label: 'Nr. Ocorrência',
        type: 'text',
        isVisible: false,
        size: 12,
        required: true,
      },
      {
        name: 'DSOCORRENCIA',
        label: 'Descrição',
        type: 'text',
        size: 12,
        onInput: this.descricaoAcidenteOnInput,
        required: true,
      },
      {
        name: 'IDOCORRENCIA',
        label: 'Identificação',
        type: 'select',
        items: [
          {
            name: 'ACIDENTE',
            label: 'Acidente',
          },
          {
            name: 'INCIDENTE',
            label: 'Incidente',
          },
        ],
        descriptionField: 'label',
        valueField: 'name',
        required: true,
        size: 12,
      },
      {
        name: 'QTVITIMASOCORRE',
        label: 'Qt de Vítimas',
        type: 'text',
        size: 3,
        readonly: false,
        isVisible: false
      }
    ];

    return fields;
  }

  private get catEsocialFields(): Field[] {
    const fields = [
      {
        name: 'DTOCORRENCIA',
        label: 'Data Ocorrência',
        type: 'date',
        size: 6,
        required: true,
        readonly: false,
      },
      {
        name: 'DTHROCORRENCIAFORMAT',
        label: 'Data Ocorrência',
        type: 'date',
        size: 6,
        required: false,
        readonly: false,
        isVisible: false
      },
      {
        name: 'HROCORRENCIA',
        label:'Hora Ocorrência',
        type: 'text',
        size: 6,
        isVisible: true,
        mask: '##:##',
        required: true,
      },
      {
        name: 'NRTIPOOCORRE',
        label: 'Fonte Geradora',
        type: 'autocomplete',
        valueField: 'NRTIPOOCORRE',
        descriptionField: 'NMTIPOOCORRE',
        size: 6,
        required: true,
        route: 'getFonteGeradora',
        reloadOnCreation: true,
        filters: this.genericFilter,
        readonly: false,
      },
      {
        name: 'DSTIPOOCORRE',
        label: 'Observação Fonte Geradora',
        type: 'text',
        size: 6,
        readonly: false,
      },
      {
        name: 'NRCLASSIFICACAO',
        required: true,
        label: 'Classificação da Ocorrência',
        type: 'autocomplete',
        valueField: 'NRCLASSIFICACAO',
        descriptionField: 'NMCLASSIFICACAO',
        size: 6,
        route: 'getClassificacaoOcorrencia',
        reloadOnCreation: true,
        filters: this.genericFilter,
        readonly: false,
      },
      {
        name: 'DSCLASSIFOCORRE',
        label: 'Observação Classificação da Ocorrencia',
        type: 'text',
        size: 6,
        readonly: false,
      },
      {
        name: 'DSOBERSVACAOOCO',
        label: 'Observação',
        type: 'textarea',
        size: 12,
        readonly: false,
      },
    ];

    return fields;
  }

  private get catInfComplementaresFields(): Field[] {
    const fields = [
      {
        name: 'DTRELATOCORRE',
        label: 'Data do Relato',
        type: 'date',
        isVisible: false,
        size: 6,
        required: false,
        readonly: false,
      },
      {
        name: 'HRRELATOCORRE',
        label:'Hora do Relato',
        type: 'text',
        size: 6,
        isVisible: false,
      },
      {
        name: 'NRGRAVIDADE',
        label: 'Gravidade da Ocorrência',
        type: 'autocomplete',
        descriptionField: 'NMGRAVIDADE',
        valueField: 'NRGRAVIDADE',
        size: 6,
        required: true,
        route: 'getGravidadeOcorrencia',
        reloadOnCreation: true,
        filters: this.genericFilter,
        readonly: false,
      },
      {
        name: 'DSGRAVIDOCORRE',
        label: 'Observação Gravidade da Ocorrência',
        type: 'text',
        size: 6,
        readonly: false,
      },
      {
        name: 'NRINFLUENCIAGERENCIAL',
        label: 'Influência Gerencial',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRINFLUENCIAGERENCIAL',
        descriptionField: 'NMINFLUENCIAGERENCIAL',
        route: 'getInfluenciaGeral',
        reloadOnCreation: true,
        filters: this.genericFilter,
        readonly: false,
      },
      {
        name: 'DSINFLUGEROCORRE',
        label: 'Observação Influência Gerencial',
        type: 'text',
        size: 6,
        readonly: false,
      },
      {
        name: 'NRCAUSA',
        label: 'Agente Causador do Acidente de Trabalho',
        type: 'autocomplete',
        descriptionField: 'NMCAUSA',
        valueField: 'NRCAUSA',
        required: true,
        size: 6,
        route: 'getAgenteCausadorAcidTrab',
        reloadOnCreation: true,
        filters: this.genericFilter,
        readonly: false,
      },
      {
        name: 'NRESTRUTURAM',
        descriptionField: this.descField,
        label: 'Estrutura Gerencial (CAT)',
        valueField: 'NRESTRUTURAM',
        type: 'autocomplete',
        size: 6,
        items: this.estruturasGerenciais,
        required: true,
        readonly: false,
      }
    ];

    return fields;
  }

    /* VÍTIMA  */
  private get vitimaFields(): Field[] {
    const fields = [
      {
        name: 'NRESTRUTLEGAL',
        label: 'Estrutura Legal',
        type: 'autocomplete',
        size: 6,
        descriptionField: 'NRNMESTRUTURA',
        valueField: 'NRESTRUTURAM',
        items: this.estruturasLegais,
        onInput: this.getVinculosByEstruturaField,
        isVisible: this.isUserAdmOrSST,
        required: this.isUserAdmOrSST
      },
      {
        name: 'NRESTRUTGEREN',
        label: 'Estrutura Gerencial',
        type: 'autocomplete',
        size: 6,
        descriptionField: this.descField,
        valueField: 'NRESTRUTURAM',
        items: this.estruturasGerenciais,
        onInput: this.getVinculosByEstruturaField,
        isVisible: this.isUserAdmOrSST,
        required: false
      },
      {
        name: 'NRVITIMA',
        label: 'Nr. Vítima',
        type: 'text',
        isVisible: false,
        size: 12,
        required: true,
      },
      {
        name: 'NRVINCULOM',
        label: 'Vítima',
        size: 6,
        required: true,
        readOnly: false,
        type: 'autocomplete',
        isVisible: true,
        descriptionField: 'NRNMVINCULO',
        valueField: 'NRVINCULOM',
        items: this.vinculos,
        outData: {
          NRVINCULOM: 'NRVINCULOM',
          NMVINCULOM: 'NMVINCULOM',
          NRPESSOAPRIN: 'NRPESSOA',
          NRPARCNEGOCIO: 'NRPARCNEGOCIO',
        },
      },
      {
        name: 'NRPARCNEGOCIO',
        label: 'Nr. Parceiro Negócio Vítima',
        descriptionField: 'NRPARCNEGOCIO',
        type: 'text',
        valueField: 'NRPARCNEGOCIO',
        size: 6,
        required: false,
        readonly: true,
        isVisible: true,
      },
      {
        name: 'DSACIDENTE',
        label: 'Descrição do Acidente',
        type: 'text',
        required: false,
        size: 12,
        readonly: true
      },
      {
        name: 'NMGRAVIDADE',
        label: 'Gravidade da Ocorrência',
        type: 'text',
        required: true,
        size: 6,
        readonly: true,
        isVisible: false

      },
      {
        name: 'NRINFLUENCIAGERENCIAL',
        label: 'Influência Gerencial',
        type: 'text',
        descriptionField: 'NMINFLUENCIAGERENCIAL',
        size: 6,
        isVisible: false,
        readonly: true
      },

      {
        name: 'IDINCAPACITADO',
        label: 'Incapacitação',
        type: 'checkbox',
        size: 6,
        valueToTrue: 'S',
        valueToFalse: 'N'
      },
      {
        name: 'IDFALTAEPI',
        label: 'Falta de EPI',
        type: 'checkbox',
        size: 6,
        valueToTrue: 'S',
        valueToFalse: 'N'
      },
    ];

    return fields;
  }

  private get vitimaEsocialFields(): Field[] {
    const fields = [
      {
        name: 'NRNATUREZA',
        label: 'Natureza da Ocorrência',
        descriptionField: 'NMNATUREZA',
        type: 'autocomplete',
        valueField: 'NRNATUREZA',
        size: 6,
        required: true,
        route: 'getNaturezaOcorrencia',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'DSNATUREZAACID',
        label: 'Observação',
        type: 'text',
        size: 6,
      },
      {
        name: 'IDTIPOCAT',
        label: 'Tipo de CAT',
        tag: 'TkSelect',
        required: true,
        type: 'select',
        items: [
          {
            name: '1',
            label: 'Inicial',
          },
          {
            name: '2',
            label: 'Reabertura',
          },
          {
            name: '3',
            label: 'Comunicação de Óbito'
          }
        ],
        descriptionField: 'label',
        valueField: 'name',
        size: 6,
        onInput: this.limpaCamposVitimaEsocial,
      },
      {
        name: 'DTOBITO',
        label: 'Data Óbito',
        type: 'date',
        size: 6,
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '3' ? false : true,
        required: this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false,
      },
      {
        name: 'IDAFASTAMENTO',
        label: 'Afastamento',
        type: 'checkbox',
        size: 4,
        valueToTrue: 'S',
        valueToFalse: 'N',
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false,
        valueField: this.rowsVitima.esocial.IDTIPOCAT === '3' ? 'N' : 'N'
      },
      {
        name: 'IDINTERNACAO',
        label: 'Internação',
        type: 'checkbox',
        size: 4,
        valueToTrue: 'S',
        valueToFalse: 'N',
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false,
        valueField: this.rowsVitima.esocial.IDTIPOCAT === '3' ? 'N' : 'N'
      },
      {
        name: 'IDREGPOLICIAL',
        label: 'Registro Policial',
        type: 'checkbox',
        size: 4,
        valueToTrue: 'S',
        valueToFalse: 'N',
        onInput: this.limpaRegistroPolicial,
      },
      {
        name: 'NRREGPOLICIAL',
        label: 'Nr. Registro Policial',
        type: 'number',
        size: 12,
        readonly: this.rowsVitima.esocial.IDREGPOLICIAL === 'S' ? false : true,
        valueField: this.rowsVitima.esocial.IDREGPOLICIAL === 'S' ? this.rowsVitima.esocial.NRREGPOLICIAL : null
      },
      {
        name: 'NRCAT',
        label: 'CAT',
        type: 'number',
        size: 6,
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '1' ? true : false,
        required: this.rowsVitima.esocial.IDTIPOCAT === '2' || this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false
      },
      {
        name: 'NRCATORIGEM',
        label: 'CAT Origem',
        type: 'number',
        size: 6,
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '1' ? true : false,
        required: this.rowsVitima.esocial.IDTIPOCAT === '2' || this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false
      },
      {
        name: 'DTCAT',
        label: 'Data Registro',
        type: 'date',
        size: 3,
        readonly: this.rowsVitima.esocial.IDTIPOCAT === '1' ? true : false,
        required: this.rowsVitima.esocial.IDTIPOCAT === '2' || this.rowsVitima.esocial.IDTIPOCAT === '3' ? true : false
      },
      {
        name: 'DSLOCALCAT',
        label: 'Descrição do Local de Registro',
        type: 'text',
        size: 9,
      },
      {
        name: 'NRTIPOLOCALCAT',
        label: 'Tipo de Local da CAT',
        descriptionField: 'DSTIPOLOCALCAT',
        type: 'autocomplete',
        valueField: 'NRTIPOLOCALCAT',
        size: 6,
        required: true,
        route: 'getTipoLocalCat',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'NRAGENTCAUSAD',
        label: 'Agente Causador',
        descriptionField: 'DSAGENTCAUSAD',
        type: 'autocomplete',
        valueField: 'NRAGENTCAUSAD',
        size: 6,
        route: 'getAgenteCausador',
        required: true,
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'NRCEPENDERECO',
        label: 'Número do CEP',
        size: '12',
        type: 'text',
        mask: '#####-###',
        onBlur: this.cepOnBlur,
      },
      {
        name: 'CDTIPOENDERECO',
        label: 'Tipo Endereço',
        size: '6',
        type: 'autocomplete',
        valueField: 'CDTIPOENDERECO',
        descriptionField: 'NMTIPOENDERECO',
        isVisible: false,
        items: this.enderecoFieldsData.tiposEndereco,
      },
      {
        name: 'CDPAIS',
        label: 'País',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        valueField: 'CDPAIS',
        descriptionField: 'NMPAIS',
        items: this.generalFieldsData.paises,
      },
      {
        name: 'SGESTADO',
        label: 'Estado',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        descriptionField: 'NMESTADO',
        valueField: 'SGESTADO',
        items: this.enderecoFieldsData.estados,
      },
      {
        name: 'CDMUNICIPIO',
        label: 'Município',
        size: 4,
        hideEmptyValue: false,
        type: 'autocomplete',
        valueField: 'CDMUNICIPIO',
        descriptionField: 'NMMUNICIPIO',
        items: this.enderecoFieldsData.municipios,
      },
      {
        name: 'NMBAIRROENDERECO',
        label: 'Bairro',
        size: '6',
        type: 'text',
      },
      {
        name: 'CDLOGRADOURO',
        label: 'Logradouro',
        size: '6',
        type: 'autocomplete',
        valueField: 'CDLOGRADOURO',
        descriptionField: 'DSLOGRADOURO',
        items: this.enderecoFieldsData.logradouros,
      },
      {
        name: 'DSENDERECO',
        label: 'Endereço',
        size: '6',
        type: 'text',
      },
      {
        name: 'NRIMOVELENDERECO',
        label: 'Número',
        size: '6',
        type: 'text',
      },
      {
        name: 'DSCOMPLEENDERECO',
        label: 'Complemento',
        size: '6',
        type: 'text',
      },
      {
        name: 'DSREFERENCIAENDE',
        label: 'Referência',
        size: '6',
        type: 'text',
      },
      {
        name: 'DTINICATEND',
        label: 'Data Inicio Atendimento',
        type: 'date',
        size: 6,
        required: true,
      },
      {
        name: 'HRINICATEND',
        label: 'Hora Inicio Atendimento',
        size: 3,
        type: 'text',
        mask: '##:##',
        required: true,
      },
      {
        name: 'QTHRATEINICATEND',
        label: 'Qt Horas até Inicio Atendimento',
        type: 'text',
        mask: '##:##',
        size: 3,
      },
      {
        name: 'DTFIMATEND',
        label: 'Data Fim Atendimento',
        type: 'date',
        size: 6,
      },
      {
        name: 'HRFIMCATEND',
        label: 'Hora Fim Atendimento',
        type: 'text',
        mask: '##:##',
        size: 3,
        required: false,
      },
      {
        name: 'QTHRATENDIMENTO',
        label: 'Qt Horas Atendimento',
        type: 'text',
        mask: '##:##',
        size: 3,
      },
      {
        name: 'QTHRAPOSINICTRAB',
        label: 'Qt Horas Trab. Antes do Acidente',
        type: 'text',
        mask: '##:##',
        size: 6,
      },
      {
        name: 'DTULTDIATRABALHADO',
        label: 'Últ. Dia Trab.',
        type: 'date',
        size: 6,
        required: true,
      },
      {
        name: 'DSOBSERVACAOVITIMA',
        label: 'Observação',
        type: 'textarea',
        size: 12,
      },
    ];

    return fields;
  }

  private get vitimaCatFields(): Field[] {
    const fields = [
      {
        name: 'IDACIDENTEBIO',
        label: 'Acidente Biológico',
        type: 'select',
        items: [
          {
            name: 'N',
            label: 'NÃO',
          },
          {
            name: 'S',
            label: 'SIM',
          },
        ],
        descriptionField: 'label',
        valueField: 'name',
        size: 12
      },
      {
        name: 'DSPROFILAXIA',
        label: 'Descrição Profilaxia',
        type: 'textarea',
        size: 12,
      },
    ];

    return fields;
  }

  private get vitimaTrabalhoFields(): Field[] {
    const fields = [   
      {
        name: 'QTDIASDEBITADOS',
        label: 'Qt Dias Debitados',
        type: 'number',
        size: 6,
      },
      {
        name: 'QTDIASTRABRESTRITO',
        label: 'Qt Dias Trab. Restrito',
        type: 'number',
        size: 6,
      },
      {
        name: 'QTDIASPERDIDOS',
        label: 'Qt Dias Perdidos',
        type: 'number',
        size: 6,
      },
      {
        name: 'QTHRPERDIDAS',
        label: 'Qt Horas Perdida',
        type: 'number',
        size: 6,
      },
    ];

    return fields;
  }

  /* Parte Atingida */
  private get parteAtingidaFields(): Field[] {
    const fields = [   
      {
        name: 'NRVITPARTEATING',
        label: 'Nr. Ocorrência',
        type: 'text',
        isVisible: false,
        size: 12,
        required: true,
      },
      {
        name: 'NRPARTEATINGIDA',
        label: 'Parte Atingida',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRPARTEATINGIDA',
        descriptionField: 'NMPARTEATINGIDA',
        route: 'getParteAtingida',
        required: true,
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'LATERALIDADE',
        label: 'Lateralidade',
        required: true,
        type: 'select',
        items: [
          {
            name: '0',
            label: 'Não aplicável',
          },
          {
            name: '1',
            label: 'Esquerda',
          },
          {
            name: '2',
            label: 'Direita',
          },
          {
            name: '3',
            label: 'Ambas',
          },
        ],
        descriptionField: 'label',
        valueField: 'name',
        size: 6
      },
      {
        name: 'DSDIAGNOSTICO',
        required: true,
        label: 'Descrição do Diagnóstico',
        type: 'text',
        size: 12,
      },
      {
        name: 'DSOBSERVACAOVPA',
        label: 'Observação',
        type: 'textarea',
        size: 12,
      },
    ];

    return fields;
  }

  /* Ficha Médica */
  private get fichaMedicaEsocialFields(): Field[] {
    const fields = [   
      {
        name: 'NRFICHAMEDICA',
        label: 'Nr. Ocorrência',
        type: 'text',
        isVisible: false,
        size: 12,
        required: true,
      },
      {
        name: 'NRPESSOA',
        label: 'Médico Atendente',
        type: 'autocomplete',
        descriptionField: 'NMPESSOA',
        valueField: 'NRPESSOA',
        size: 12,
        required: true,
        reloadOnCreation: true,
        items: this.pessoasConseReg,
        outData: {
          NRINSCRCONSELHOATEND: 'NRINSCRCONSREG',
          NRPARCNEGOCIOMEDICO: 'NRPARCNEGOCIO',
          NRPESSOA: "NRPESSOA",
          NMPESSOA: "NMPESSOA",
        },
        onInput: this.inputDadosMedico,
      },
      {
        name: 'NRPARCNEGOCIOMEDICO',
        descriptionField: 'NRPARCNEGOCIOMEDICO',
        label: 'Nr. Parceiro Negócio Médico',
        type: 'text',
        valueField: 'NRPARCNEGOCIOMEDICO',
        size: 6,
        required: false,
        readonly: true,
        isVisible: true,
       
      },
      {
        name: 'NRINSCRCONSELHOATEND',
        label: 'Nr. Inscrição do Atendente no Conselho',
        type: 'text',
        size: 6,
        required: false,
        readonly: true
      },
      {
        name: 'DTHRINIAFASTAMENTO',
        label: 'Data Início Afastamento',
        type: 'date',
        size: 12,
        isVisible: true,
        mask: '##/##/##',
      },
      {
        name: 'DTHRFIMAFASTAMENTO',
        label: 'Data Fim Afastamento',
        type: 'date',
        size: 12,
        isVisible: true,
        mask: '##/##/##',
      }
    ];

    return fields;
  }

  private get fichaMedicaAtendimentoFields(): Field[] {
    const fields = [
      {
        name: 'NRNATUREZAEXAME',
        label: 'Natureza do Exame',
        type: 'autocomplete',
        valueField: 'NRNATUREZAEXAME',
        size: 6,
        descriptionField: 'NMNATUREZAEXAME',
        route: 'getNaturezaExame',
        reloadOnCreation: true,
        filters: this.genericFilter,
        isVisible: false,
      },
      {
        name: 'NRESTRUTURAMUNIDATENDIMENTO',
        label: 'Unidade do Atendimento',
        descriptionField: 'NMESTRUTURAH',
        type: 'autocomplete',
        valueField: 'NRESTRUTURAMUNIDATENDIMENTO',
        route: 'getEstruturas',
        reloadOnCreation: true,
        filters: this.genericFilter,
        size: 12,
        isVisible: false,
      },
      {
        name: 'DSLOCALATENDIMENTO',
        label: 'Local do Atendimento',
        type: 'text',
        isVisible: false,
        size: 12,
      },
      {
        name: 'DTCONCLFICHAMED',
        label: 'Data de Conclusão',
        type: 'date',
        size: 12,
        required: true,
      },
      {
        name: 'NRMOTIVOAUSENCIA',
        label: 'Motivo da Ausência',
        type: 'autocomplete',
        valueField: 'NRMOTIVOAUSENCIA',
        size: 5,
        descriptionField: 'DSMOTIVOAUSENCIA',
        route: 'getMotivoAusencia',
        isVisible: false,
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'NRQUEIXA',
        label: 'Queixa',
        type: 'autocomplete',
        size: 5,
        valueField: 'NRQUEIXA',
        descriptionField: 'DSQUEIXA',
        route: 'getQueixa',
        isVisible: false,
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
    ];

    return fields;
  }

  private get fichaMedicaFields(): Field[] {
    const fields = [   
      {
        name: 'NRTABRESULTEXAME',
        label: 'Resultado de Exame',
        type: 'autocomplete',
        size: 12,
        valueField: 'NRTABRESULTEXAME',
        descriptionField: 'DSTABRESULTEXAME',
        route: 'getResultadoExame',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'NRCONTROLEAPTIDAOATEND',
        label: 'Parecer Médico',
        type: 'autocomplete',
        valueField: 'NRCONTROLEAPTIDAOATEND',
        descriptionField: 'DSCONTROLEAPTIDAO',
        size: 6,
        route: 'getControleapt',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },     
      {
        name: 'NRCONTROLEAPTIDAOINSS',
        label: 'Parecer INSS',
        type: 'autocomplete',
        valueField: 'NRCONTROLEAPTIDAOINSS',
        descriptionField: 'DSCONTROLEAPTIDAO',
        size: 6,
        route: 'getControleapt',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'IDNEXOCAUSAL',
        label: 'Nexo Causal',
        type: 'select',
        items: [
          {
            name: 'S',
            label: 'Sim',
          },
          {
            name: 'N',
            label: 'Não',
          },
        ],
        descriptionField: 'label',
        valueField: 'name',
        size: 4
      },
      {
        name: 'NRCAT',
        label: 'nr. do CAT',
        type: 'number',
        size: 4,
      },
      {
        name: 'NRBENEFICIO',
        label: 'Nr. Benefício',
        type: 'number',
        size: 4,
      },
      {
        name: 'DSOCORRENCIA',
        label: 'Descrição Benefício',
        type: 'number',
        size: 6,
        readonly: true,
      },
      {
        name: 'NRSITUFUNCM',
        label: 'Situação',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRSITUFUNCM',
        descriptionField: 'NMSITUFUNCH',
        route: 'getSituacao',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
      {
        name: 'DTPREVRETORNO',
        label: 'Data Prevista de Retorno',
        type: 'date',
        size: 6,
      },
      {
        name: 'NMSITUFUNCHPROX',
        label: 'Próxima Situação',
        type: 'autocomplete',
        size: 6,
        valueField: 'NRSITUFUNCMPROX',
        descriptionField: 'NMSITUFUNCH',
        route: 'getProximaSituacao',
        reloadOnCreation: true,
        filters: this.genericFilter,
      },
    ];

    return fields;
  }

  private get fichaMedicaIMCFields(): Field[] {
    const fields = [   
      {
        name: 'QTPESO',
        label: 'Peso (Kg)',
        type: 'number',
        size: 3,
        onInput: this.calcularIMC
      },
      {
        name: 'VRALTURA',
        label: 'Altura (m)',
        type: 'number',
        size: 3,
        onInput: this.calcularIMC
      },
      {
        name: 'VRIMC',
        label: 'IMC',
        type: 'number',
        size: 3,
        readonly: true
      },
      {
        name: 'GRAUOBESIDADE',
        label: 'Grau de Obesidade',
        type: 'text',
        size: 3,
        readonly: true
      },
    ];

    return fields;
  }

  private get fichaMedicaSinaisVitaisFields(): Field[] {
    const fields = [
      {
        name: 'VRTEMPERATURA',
        label: 'Temperatura (ºC)',
        type: 'number',
        size: 3,
      },
      {
        name: 'VRPULSO',
        label: 'Pulso (bpm)',
        type: 'number',
        size: 3,
      },
      {
        name: 'VRPRESSAOARTSISTOLICA',
        label: 'Pressão Arterial Sistólica (mmHg)',
        type: 'number',
        size: 3,
      },
      {
        name: 'VRPRESSAOARTDIASTOLICA',
        label: 'Pressão Arterial Diastólica (mmHg)',
        type: 'number',
        size: 3,
      },
    ];

    return fields;
  }

  /* Doença */
  private get doencaFields(): Field[] {
    const fields = [   
      {
        name: 'NRDOENCAFICHAMEDICA',
        label: 'Nr. Doença ficha Medica',
        type: 'text',
        isVisible: false,
        size: 12,
        required: true,
      },
      {
        name: 'NRCID',
        label: 'CID', 
        items: this.cid,
        type: 'autocomplete',
        size: 6,
        required: true,
        valueField: 'NRCID',
        descriptionField: 'CDCID',
        reloadOnCreation: true,
        outData: {
          DSCID: 'DSCID',
        },
      },
      {
        name: 'DSCID',
        label: 'Doença',
        type: 'text',
        readonly: true,
      },
      {
        name: 'DSDOENCAFICHAMEDICA',
        label: 'Descrição',
        required: true,
        type: 'text',
        size: 6,
      },
      {
        name: 'IDOCUPACIONAL',
        label: 'Doença Ocupacional',
        type: 'checkbox',
        size: 6,
        valueToTrue: 'S',
        valueToFalse: 'N',
      },
    ];

    return fields;
  }

  private get dadosOcorrenciaCATIsValid(): boolean {
    const dadossOcorrenciaCATPanelsValidation = [
      this.panelsValidation.cat,
      this.panelsValidation.catEsocial,
      this.panelsValidation.catInfComplementares,
    ];

    const isValid = Util.allTrue(...dadossOcorrenciaCATPanelsValidation);

    return isValid;
  }

  private get dadosVitimaIsValid(): boolean {
    const dadosVitimaPanelsValidation = [
      this.panelsValidation.vitima,
      this.panelsValidation.vitimaEsocial,
      this.panelsValidation.vitimaCAT,
      this.panelsValidation.vitimaTrabalho,
    ];

    const isValid = Util.allTrue(...dadosVitimaPanelsValidation);

    return isValid;
  }

  private get dadosParteAtingidaIsValid(): boolean {
    const dadosParteAtingidaPanelsValidation = [
      this.panelsValidation.parteAtingida,
    ];

    const isValid = Util.allTrue(...dadosParteAtingidaPanelsValidation);

    return isValid;
  }

  private get dadosDoencaIsValid(): boolean {
    const dadosDoencaPanelsValidation = [
      this.panelsValidation.doenca,
    ];

    const isValid = Util.allTrue(...dadosDoencaPanelsValidation);

    return isValid;
  }

  private get dadosFichaMedicaIsValid(): boolean {
    const dadosDoencaPanelsValidation = [
      this.panelsValidation.fichaMedicaEsocial,
      this.panelsValidation.fichaMedicaAtendimento,
    ];

    const isValid = Util.allTrue(...dadosDoencaPanelsValidation);

    return isValid;
  }


  private get isValid(): boolean {
    const validationArray = Object.values(this.panelsValidation);
    const isValid = Util.allTrue(...validationArray);

    return isValid;
  }

  private get emptyRequiredFields() {
    const cat = Util.getFormEmptyRequiredFields(
      this.rowsCAT.cat, this.catFields
    );

    const catEsocial = Util.getFormEmptyRequiredFields(
      this.rowsCAT.esocial, this.catEsocialFields
    );

    const catInfComplementares = Util.getFormEmptyRequiredFields(
      this.rowsCAT.infComplementares, this.catInfComplementaresFields
    );

    const vitima = Util.getFormEmptyRequiredFields(
      this.rowsVitima.vitima, this.vitimaFields
    );

    const vitimaEsocial = Util.getFormEmptyRequiredFields(
      this.rowsVitima.esocial, this.vitimaEsocialFields
    );

    const vitimaCAT = Util.getFormEmptyRequiredFields(
      this.rowsVitima.catVitima, this.vitimaCatFields
    );

    const vitimaTrabalho = Util.getFormEmptyRequiredFields(
      this.rowsVitima.trabalho, this.vitimaTrabalhoFields
    );

    const parteAtingida = Util.getFormEmptyRequiredFields(
      this.rowsParteAtingida.parteAtingida, this.parteAtingidaFields
    );

    const doenca = Util.getFormEmptyRequiredFields(
      this.rowsDoenca.doenca, this.doencaFields
    );

    const fichaMedicaEsocial = Util.getFormEmptyRequiredFields(
      this.rowsFichaMedica.esocial, this.fichaMedicaEsocialFields
    );

    const fichaMedicaAtendimento = Util.getFormEmptyRequiredFields(
      this.rowsFichaMedica.atendimento, this.fichaMedicaAtendimentoFields
    );

    const relation = {
      cat: cat,
      catEsocial: catEsocial,
      catInfComplementares: catInfComplementares,
      vitima: vitima,
      vitimaEsocial: vitimaEsocial,
      vitimaCAT: vitimaCAT,
      vitimaTrabalho: vitimaTrabalho,
      parteAtingida: parteAtingida,
      doenca: doenca,
      fichaMedicaEsocial: fichaMedicaEsocial,
      fichaMedicaAtendimento:  fichaMedicaAtendimento
    };

    return relation;
  }



  private get allEmptyRequired() {
    const emptyRequired = {
      ...this.emptyRequiredFields,
    };

    return emptyRequired;
  }

  private get dadosCATTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.cat,
      ...this.emptyRequiredFields.catEsocial,
      ...this.emptyRequiredFields.catInfComplementares
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }

  private get dadosVitimaTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.vitima,
      ...this.emptyRequiredFields.vitimaEsocial,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }

  private get dadosParteAtingidaTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.parteAtingida,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }


  private get dadosFichaMedicaTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.fichaMedicaEsocial,
      ...this.emptyRequiredFields.fichaMedicaAtendimento,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }


  private get dadosDoencaTooltip(): string {
    const fields = [
      ...this.emptyRequiredFields.doenca,
    ];

    if (fields.length > 6) {
      return 'Preencha os campos obrigatórios!';
    }

    const tooltip = this.getPanelTooltip(fields);

    return tooltip;
  }


  private get panelsValidation() {
    const validation: { [index: string]: boolean } = {};

    const emptyRequired = this.allEmptyRequired

    const panelsNames = Object.keys(emptyRequired);

    panelsNames.forEach((panelName) => {
      const value: Field[] = emptyRequired[panelName];
      const isValid = value.length === 0;

      validation[panelName] = isValid;
    });

    if (this.mode === 'view') {
      Object.keys(validation).forEach((name) => {
        validation[name] = true;
      });
    }

    return validation;
  }


  private get tooltips(): { [index: string]: string } {
    const panelsNames = Object.keys(this.allEmptyRequired);

    const tooltips = panelsNames.reduce((accumulator, panelName) => {
      const value: Field[] = this.allEmptyRequired[panelName];
      const tooltip = this.getPanelTooltip(value);

      accumulator[panelName] = tooltip;

      return accumulator;
    }, {});

    return tooltips;
  }

  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    
  }

  private mounted() {
    this.setPopupHeight();
    this.loadEstruturasGerenciais();
    this.loadEstruturasLegais();
    this.loadVitimas();
    this.getPessoaConselhoReg();
    this.getCID();
    this.loadFieldsData();
    window.addEventListener('resize', this.setPopupHeight);
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    this.rowsCAT = { cat: {}, esocial: {}, infComplementares: {} };
    this.rowsVitima = { vitima: {}, esocial: {}, catVitima: {}, trabalho: {} };
    this.rowsParteAtingida = { parteAtingida: {} };
    this.rowsFichaMedica = { esocial: {}, atendimento: {}, fichaMedica: {}, sinaisVitais: {}, imc: {} };
    this.rowsDoenca = { doenca: {} };
  
    if (this.internalValue) {
      this.row = Util.deepCopy(this.presetRow ? this.presetRow : this.defaultRow);
      const populateCategory = (categoryFields: string[], target: any) => {
        categoryFields.forEach(fieldName => {
          if (fieldName in this.row) {
            target[fieldName] = this.row[fieldName];
          }
        });
      };

      if(this.mode !== 'new') {
        populateCategory(this.fieldCategoryMapCAT.cat, this.rowsCAT.cat);
        populateCategory(this.fieldCategoryMapCAT.esocial, this.rowsCAT.esocial);
        populateCategory(this.fieldCategoryMapCAT.infComplementares, this.rowsCAT.infComplementares);
        populateCategory(this.fieldCategoryMapVitima.vitima, this.rowsVitima.vitima);
        populateCategory(this.fieldCategoryMapVitima.esocial, this.rowsVitima.esocial);
        populateCategory(this.fieldCategoryMapVitima.catVitima, this.rowsVitima.catVitima);
        populateCategory(this.fieldCategoryMapVitima.trabalho, this.rowsVitima.trabalho);
  
        populateCategory(this.fieldCategoryMapParteAtingida.parteAtingida, this.rowsParteAtingida.parteAtingida);
  
        populateCategory(this.fieldCategoryMapFichaMedica.esocial, this.rowsFichaMedica.esocial);
        populateCategory(this.fieldCategoryMapFichaMedica.atendimento, this.rowsFichaMedica.atendimento);
        populateCategory(this.fieldCategoryMapFichaMedica.fichaMedica, this.rowsFichaMedica.fichaMedica);
        populateCategory(this.fieldCategoryMapFichaMedica.sinaisVitais, this.rowsFichaMedica.sinaisVitais);
        populateCategory(this.fieldCategoryMapFichaMedica.imc, this.rowsFichaMedica.imc);
  
        populateCategory(this.fieldCategoryMapDoenca.doenca, this.rowsDoenca.doenca);
  
        if (this.rowsVitima.vitima.NRVINCULOM) {
          this.rowsVitima.vitima.NRVINCULOM = parseInt(this.rowsVitima.vitima.NRVINCULOM, 10);
        }
      }


      if (this.vinculos === null) {
        this.reloadVinculos();
      }
  
      this.openPanels();
  
    }
  }

  @Watch('rowsVitima.esocial', { deep: true })
  private onRowsVitimaEsocialChange(newValue: any) {
    if (newValue.IDTIPOCAT) {
      //this.onChangeTipoCat(newValue.IDTIPOCAT);
    }
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.vinculos = null;
  }

  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
    this.makeDadosPessoaisPopupsEditable();
  }

  private async save() {

    let is_new = null;
    
    if (!this.isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return;
    }

    await DialogUtils.show(
      'Finalizar CAT',
      'Deseja realmente finalizar o Comunicado de Acidente de Trabalho?'
    );
  
  
      
    const dadosCAT = {
      ...this.rowsCAT.cat,
      ...this.rowsCAT.esocial,
      ...this.rowsCAT.infComplementares,
    };
    
    const dadosVitima = {
      ...this.rowsVitima.vitima,
      ...this.rowsVitima.esocial,
      ...this.rowsVitima.catVitima,
      ...this.rowsVitima.trabalho,
    };

    const dadosFichaMedica = {
      ...this.rowsFichaMedica.atendimento,
      ...this.rowsFichaMedica.esocial,
      ...this.rowsFichaMedica.fichaMedica,
      ...this.rowsFichaMedica.sinaisVitais,
      ...this.rowsFichaMedica.imc,
    };

    const dadosParteAtingida = {
      ...this.rowsParteAtingida.parteAtingida,
    };

    const dadosDoenca = {
      ...this.rowsDoenca.doenca,
    };
    
    const mode = this.mode === 'edit' ?
    'edit' :
    'new';
    
    if(mode == 'edit') {
       is_new = false;
    }
    
    if(mode == 'new'){
      is_new = true;
    }
    
    
    
    const row: any = {
      dadosCAT,
      dadosVitima,
      dadosFichaMedica,
      dadosParteAtingida,
      dadosDoenca,
      is_new
    };
  
    try {
      let data = null;
      data = await ComunicadoAcidenteTrabalhoController.setComunicadoAcidenteTrabalho(row);
      const message = 'Comunicado de Acidente de Trabalho salvo com sucesso.';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_SUCCESS);
      this.closeDialog();
      this.$emit('after-save');
    } catch (err) {
      const message = err instanceof ExpectedError ?
        err.message :
        'Não foi possível salvar o Comunicado de Acidente de Trabalho!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }

  private setDefaultRows() {
    //
  }


  private empresaOnFieldInput(fieldName: string) {
    if (fieldName === 'NRESTRUTGEREN') {
      this.setEstruturaLegalByGeren();
    }
  }

  private setEstruturaLegalByGeren() {
    //  const nrEstrutGeren = this.rowsDadosVinculo.empresa.NRESTRUTGEREN;

    //if(nrEstrutGeren) {
    //const estruturaGeren = this.dadosVinculosFieldsData.estruturasGerenciais.find((estrutura) => estrutura.NRESTRUTURAM == nrEstrutGeren);
    // if(estruturaGeren && estruturaGeren.NRESTRUTLEGAL) {
    // this.rowsDadosVinculo.empresa.NRESTRUTLEGAL = estruturaGeren.NRESTRUTLEGAL;
    //}
    // }
  }

  private makeDadosPessoaisPopupsReadOnly() {
    this.dadosPessoaisFormMode = 'view';

  }

  private makeDadosPessoaisPopupsEditable() {
    this.dadosPessoaisFormMode = 'edit';
  }


  private showErrorMessage(fieldName: string) {
    const message = `
      Não foi possível carregar os dados do campo "${fieldName}"!`;

    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR, 5000);
  }

  private async loadFieldsData() {
    this.loadGeneralFieldsData();
    this.loadEnderecoFieldsData();
  }

  private loadGeneralFieldsData() {
    this.loadPaises();
    this.loadEstadosBR();
  }

  private setRowsFromProp() {

  }

  private setDadosPessoaisRowFromProp() {

  }


  private clearFields(isCPF: boolean = false) {


  }

  private setPopupHeight() {
    const windowHeight = window.innerHeight;
    this.dialogHeight = windowHeight - 218;
  }

  private openPanels() {
    this.mainPanelsExpansion = Util.deepCopy(this.defaultMainPanelsExpansion);
    this.dadosCATPanelsExpansion = Util.deepCopy(this.defaultDadosCATPanelsExpansion);
    this.dadosVitimaPanelsExpansion = Util.deepCopy(this.defaultDadosVitimaPanelsExpansion);
    this.dadosParteAtingidaPanelsExpansion = Util.deepCopy(this.defaultDadosParteAtingidaPanelsExpansion);
    this.dadosFichaMedicaPanelsExpansion = Util.deepCopy(this.defaultDadosFichaMedicaPanelsExpansion);
    this.dadosDoencaPanelsExpansion = Util.deepCopy(this.defaultDadosDoencaPanelsExpansion)
  }

  private getPanelTooltip(
    emptyRequiredFields: Field[],
  ): string {
    const lastIndex = emptyRequiredFields.length - 1;

    if (emptyRequiredFields.length === 0) {
      return 'Campos obrigatórios preenchidos.';
    }

    const tooltip = emptyRequiredFields.reduce((accumulator, field, index) => {
      accumulator += `"${field.label}"`;

      accumulator += index === lastIndex ?
        '.' :
        ', ';

      return accumulator;
    }, 'Preencha os campos: ');

    return tooltip;
  }

  private async validationEstrutGerenELegal() {
    /* const hierarquia = await SolicitacaoController.getHierarquiaByEstruturaLegalAndGeren(this.rowsDadosVinculo.empresa.NRESTRUTLEGAL, this.rowsDadosVinculo.empresa.NRESTRUTGEREN)
 
     if(hierarquia && !hierarquia.length) {
       await DialogUtils.show('Aviso', Messages.SOLIC_ESTRUTGEREN_NOT_RELAC_ESTRUTLEGAL, () => {}, () => {}, false, true);
       return false;
     } 
   
     return true;
     */
  }

  // Load campos Endereço
  private async loadPaises() {
    try {
      const paises = await AdmissaoController.getPais();
      this.generalFieldsData.paises = paises;
    } catch {
      this.showErrorMessage('País');
    }
  }

  private async loadEstadosBR() {
    try {
      const estadosBR = await AdmissaoController.getEstado();
      this.generalFieldsData.estadosBR = estadosBR;
    } catch {
      this.showErrorMessage('Estado');
    }
  }

  private cepOnBlur() {
    this.fillByCEP();
  }

  private async fillByCEP() {
    const cep: string = this.rowsVitima.esocial.NRCEPENDERECO;
    const cepIsValid = DocumentoUtil.cepIsValid(cep);
    if (!cepIsValid) {
      return;
    }

    this.fillDirectlyByCep(cep);
  }

  private async fillDirectlyByCep(cep: string) {
    if (!cep) {
      return;
    }

    const cepInfo = await AdmissaoController.pesquisarCep(cep);

    this.fillPais();
    await this.fillEstado(cepInfo);
    await this.fillMunicipio(cepInfo);
    this.fillBairro(cepInfo);
    this.fillLogradouro(cepInfo);
    this.fillEndereco(cepInfo);

  }

  private fillPais(): boolean {
    this.rowsVitima.esocial.CDPAIS = '0055';

    return true;
  }

  private async fillEstado(
    cepInfo: any
  ) {
    const uf: string = cepInfo.uf;

    await this.loadEnderecoEstados();

    if (uf) {
      const estado = this.enderecoFieldsData.estados.find((estado: any) => {
        return estado.SGESTADO === uf;
      });

      if (estado) {
        this.rowsVitima.esocial.SGESTADO = estado.SGESTADO;

        return true;
      }
    }

    this.rowsVitima.esocial.SGESTADO = null;

    return false;
  }

  private async fillMunicipio(
    cepInfo: any
  ) {
    const cidadeCodigoIBGE: string = cepInfo.ibge;

    if (cidadeCodigoIBGE && this.rowsVitima.esocial.SGESTADO) {
      await this.loadEnderecoMunicipios();

      const cidade = this.enderecoFieldsData.municipios.find((municipio: any) => {
        return municipio.CDMUNICIBGE === cidadeCodigoIBGE;
      });

      if (cidade) {
        this.rowsVitima.esocial.CDMUNICIPIO = cidade.CDMUNICIPIO;

        return true;
      }
    }

    this.rowsVitima.esocial.CDMUNICIPIO = null;

    return false;
  }

  private fillBairro(
    cepInfo: any
  ): boolean {
    const bairro = cepInfo.bairro;

    if (bairro) {
      this.rowsVitima.esocial.NMBAIRROENDERECO = bairro;

      return true;
    }

    this.rowsVitima.esocial.NMBAIRROENDERECO = null;

    return false;
  }

  private fillEndereco(
    cepInfo: any,
  ): boolean {
    const endereco: string = cepInfo.logradouro;

    if (endereco) {
      this.rowsVitima.esocial.DSENDERECO = endereco;

      return true;
    }

    this.rowsVitima.esocial.DSENDERECO = null;

    return false;
  }

  private fillLogradouro(
    cepInfo: any,
  ): boolean {
    const endereco: string = cepInfo.logradouro;

    if (endereco) {
      const logradouro = this.enderecoFieldsData.logradouros.find((logra: any) => {
        const includes = endereco.includes(logra.DSLOGRADOURO);
        return includes;
      });

      if (logradouro) {
        this.rowsVitima.esocial.CDLOGRADOURO = logradouro.CDLOGRADOURO;

        return true;
      }
    }

    this.rowsVitima.esocial.CDLOGRADOURO = null;

    return false;
  }

  private loadEnderecoFieldsData() {
    this.loadTiposEndereco();
    this.loadLogradouros();
    this.loadEnderecoEstados();
  }

  private async loadTiposEndereco() {
    try {
      const tiposEndereco = await AdmissaoController.getTpEndereco();
      this.enderecoFieldsData.tiposEndereco = tiposEndereco;
    } catch {
      this.showErrorMessage('Tipo Endereço');
    }
  }

  private async loadLogradouros() {
    try {
      const logradouros = await AdmissaoController.getLogradouro();
      this.enderecoFieldsData.logradouros = logradouros;
    } catch {
      this.showErrorMessage('Endereço → Logradouro');
    }
  }

  private async loadEnderecoEstados() {
    try {
      const cdPais: string = this.rowsVitima.esocial.CDPAIS;

      if (!cdPais) {
        return;
      }

      const estados = await AdmissaoController.getEstado(cdPais);

      this.enderecoFieldsData.estados = estados;
    } catch {
      this.showErrorMessage('Endereço → Estado');
    }
  }

  private async loadEnderecoMunicipios() {
    try {
      const cdPais: string = this.rowsVitima.esocial.CDPAIS;
      const sgEstado: string = this.rowsVitima.esocial.SGESTADO;
      const municipios = await AdmissaoController.getMunicipio(cdPais, sgEstado);

      this.enderecoFieldsData.municipios = municipios;
    } catch {
      this.showErrorMessage('Município');
    }
  }

  private async loadEstruturasGerenciais() {
    let estruturas = [];

    if (this.isUserAdmOrSST) {
      try {
        estruturas = await NovaSolicitacaoController.getEstruturas('GERENCIAL');
      } catch {
        const message = 'Não foi possível carregar as estruturas gerenciais!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      }
    } else {
      estruturas = this.estruturasGerenciaisStore.filter((estrutura) => {
        const isGerencial = estrutura.IDTIPOESTRUTURA === 'GERENCIAL';
        return isGerencial;
      });
    }

    this.estruturasGerenciais = estruturas;
  }

  private async loadEstruturasLegais() {
    let estruturas = [];

    if(!this.isUserAdmOrSST) return;

    try {
      estruturas = await NovaSolicitacaoController.getEstruturas('LEGAL');
    } catch {
      const message = 'Não foi possível carregar as estruturas legais!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }

    this.estruturasLegais = estruturas;
  }


  // load Vítimas
  private async loadVitimas() {
    this.vitimas = await NovaSolicitacaoController.getParcnegocioVinculos();
  }

  private async getPessoaConselhoReg() {
    const route = "getPessoaConselhoReg";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.pessoasConseReg = rows;
  }

  private async getCID() {
    const route = "getCID";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.cid = rows;
  }


  // OnInput Methods
  private descricaoAcidenteOnInput() {

    const descricaoCAT: string = this.rowsCAT.cat.DSOCORRENCIA;

    this.rowsVitima.vitima = { ...this.rowsVitima.vitima, DSACIDENTE: descricaoCAT };
  }

  private calcularIMC() {
    let   IMC    : number | undefined;
    const altura : number = this.rowsFichaMedica.imc.VRALTURA;
    const peso   : number = this.rowsFichaMedica.imc.QTPESO;

    if (peso && altura) {
      IMC = peso / Math.pow(altura, 2);
      this.rowsFichaMedica.imc.VRIMC = IMC.toString();
      this.rowsFichaMedica.imc.GRAUOBESIDADE = this.getGrauObesidade(IMC);
    } else {
      this.rowsFichaMedica.imc.VRIMC = "";
      this.rowsFichaMedica.imc.GRAUOBESIDADE = "";
    }
  }

  private getGrauObesidade(imc: number): string {
    const graus = [
      { min: 0,    max: 16,        grau: 'Magreza grave'                },
      { min: 16,   max: 17,        grau: 'Magreza moderada'             },
      { min: 17,   max: 18.5,      grau: 'Magreza leve'                 },
      { min: 18.5, max: 24.9,      grau: 'Saudável'                     },
      { min: 25,   max: 29.9,      grau: 'Sobrepeso'                    },
      { min: 30,   max: 34.9,      grau: 'Obesidade Grau I'             },
      { min: 35,   max: 39.9,      grau: 'Obesidade Grau II (severa)'   },
      { min: 40,   max: Infinity,  grau: 'Obesidade Grau III (mórbida)' },
    ];

    const grau = graus.find(g => imc >= g.min && imc < g.max);
    return grau ? grau.grau : 'IMC fora do intervalo';
  }

  private limpaRegistroPolicial() {
    const idRegistroPolicial: string = this.rowsVitima.esocial.IDREGPOLICIAL;
    if(idRegistroPolicial === 'N') {
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, NRREGPOLICIAL: null };
    }
  }

  private limpaCamposVitimaEsocial() {
    const idTipoCAT: string = this.rowsVitima.esocial.IDTIPOCAT;
    if(idTipoCAT === '1') {
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, DTOBITO: null };
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, NRCAT: null };
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, NRCATORIGEM: null };
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, DTCAT: null };
    }

    if(idTipoCAT === '2') {
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, DTOBITO: null };
    }

    if(idTipoCAT === '3') {
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, IDAFASTAMENTO : false };
      this.rowsVitima.esocial = { ...this.rowsVitima.esocial, IDINTERNACAO : false };
    }
   
  }

  private async reloadVinculos2() {
    const nrestrutura = this.idOperadorSST ? '-1' : null;
    const vinculos = await CommonRequests.getVinculosDoGestor(true, nrestrutura);
    this.vinculos = vinculos;
  }
  

  private inputDadosMedico(value: any) {
    const nrvinculom = this.rowsFichaMedica.esocial.NRPESSOA;
  }

  private async getVinculosByEstruturaField() {
    const nrestrutlegal = this.rowsVitima.vitima.NRESTRUTLEGAL;
    const nrestrutgeren = this.rowsVitima.vitima.NRESTRUTGEREN;
  
    if (nrestrutgeren) {
      await this.reloadVinculos(nrestrutgeren);
      return;
    }
  
    if (nrestrutlegal && !nrestrutgeren && this.isUserAdmOrSST) {
      await this.reloadVinculos(nrestrutlegal);
      return;
    }
  
    this.reloadVinculos();
  }

  private async reloadVinculos(nrestrutura?: any) {
    if(!nrestrutura) {
      nrestrutura = this.isUserAdmOrSST ? '-1' : null; 
    }

    const vinculos = await CommonRequests.getVinculosDoGestor(true, nrestrutura);
    this.vinculos = vinculos;
  }


  // #endregion
}

export default NovoComunicadoAcidenteTrabalhoPopup;

